import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
// import logo
// import logoSm from "assets/images/logo-sm.png";
// import logoDark from "assets/images/logo-dark.png";
// import logoLight from "assets/images/logo-light.png";

//Import Components
import VerticalLayout from "./VerticalLayouts";
import TwoColumnLayout from "./TwoColumnLayout";
import { Container } from "reactstrap";
import HorizontalLayout from "./HorizontalLayout";
import { MaterialRequestPendingCountProvider } from "features/MaterialRequests/context/MaterialRequestPendingCountContext";
import { ReadyForBillingWorkOrderCountProvider } from "features/WorkOrders/context/ReadyForBillingWorkOrderCountContext";
import { ReadyForBillingPettyWorkCountProvider } from "features/PettyWorks/context/ReadyForBillingPettyWorkCountContext";

const Sidebar = ({ layoutType }: any) => {
  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  });

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (
      document.documentElement.getAttribute("data-sidebar-size") === "sm-hover"
    ) {
      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active",
      );
    } else if (
      document.documentElement.getAttribute("data-sidebar-size") ===
      "sm-hover-active"
    ) {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    } else {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    }
  };

  return (
    <MaterialRequestPendingCountProvider>
    <ReadyForBillingWorkOrderCountProvider>
    <ReadyForBillingPettyWorkCountProvider>
      <React.Fragment>
      <div className="app-menu navbar-menu">
        <div className="navbar-brand-box">
          {/* Original logo (commented out)
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img
                src={logoSm}
                alt=""
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" />
            </span>
          </Link>
          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img
                src={logoSm}
                alt=""
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </span>
            <span className="logo-lg">
              <img src={logoLight} alt="Logo" />
            </span>
          </Link>
          */}
          {/* Dark theme logo */}
          <Link to="/" className="logo logo-dark text-decoration-none">
            <span className="d-flex align-items-center" style={{ minHeight: "70px", padding: "0 8px", gap: "10px" }}>
              <span style={{ fontWeight: 800, fontSize: "22px", letterSpacing: "1px", color: "var(--vz-primary)", flexShrink: 0 }}>AE</span>
              <span className="logo-lg" style={{ lineHeight: 1.2 }}>
                <span style={{ display: "block", fontSize: "10px", fontWeight: 600, letterSpacing: "2.5px", textTransform: "uppercase", color: "var(--vz-secondary-color)", marginBottom: "2px" }}>Automation</span>
                <span style={{ display: "block", fontSize: "16px", fontWeight: 700, letterSpacing: "0.2px", color: "var(--vz-dark)" }}>Engineers</span>
              </span>
            </span>
          </Link>
          {/* Light theme logo */}
          <Link to="/" className="logo logo-light text-decoration-none">
            <span className="d-flex align-items-center" style={{ minHeight: "70px", padding: "0 8px", gap: "10px" }}>
              <span style={{ fontWeight: 800, fontSize: "22px", letterSpacing: "1px", color: "#fff", flexShrink: 0 }}>AE</span>
              <span className="logo-lg" style={{ lineHeight: 1.2 }}>
                <span style={{ display: "block", fontSize: "10px", fontWeight: 600, letterSpacing: "2.5px", textTransform: "uppercase", color: "rgba(255,255,255,0.55)", marginBottom: "2px" }}>Automation</span>
                <span style={{ display: "block", fontSize: "16px", fontWeight: 700, letterSpacing: "0.2px", color: "#fff" }}>Engineers</span>
              </span>
            </span>
          </Link>
          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>
        {layoutType === "horizontal" ? (
          <div id="scrollbar">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <HorizontalLayout />
              </ul>
            </Container>
          </div>
        ) : layoutType === "twocolumn" ? (
          <React.Fragment>
            <TwoColumnLayout layoutType={layoutType} />
            <div className="sidebar-background"></div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <SimpleBar id="scrollbar" className="h-100">
              <Container fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <VerticalLayout layoutType={layoutType} />
                </ul>
              </Container>
            </SimpleBar>
            <div className="sidebar-background"></div>
          </React.Fragment>
        )}
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
    </ReadyForBillingPettyWorkCountProvider>
    </ReadyForBillingWorkOrderCountProvider>
    </MaterialRequestPendingCountProvider>
  );
};

export default Sidebar;
